// Standard CRC-32 (IEEE 802.3, reflected, poly 0xEDB88320), identical to
// zlib.crc32 / Java's java.util.zip.CRC32. Used for the tablet QR codes.

let table: Uint32Array | null = null;

function getTable(): Uint32Array {
  if (table) return table;
  table = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    table[n] = c >>> 0;
  }
  return table;
}

/** CRC-32 of the UTF-8 encoding of `input`, as an unsigned 32-bit integer. */
export function crc32(input: string): number {
  const t = getTable();
  const bytes = new TextEncoder().encode(input);
  let crc = 0xffffffff;
  for (let i = 0; i < bytes.length; i++) {
    crc = t[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
  }
  return (crc ^ 0xffffffff) >>> 0;
}

/**
 * CRC-32 as uppercase hex WITHOUT zero padding, e.g. "182A4229" or "ABC1234".
 * The wall tablet app builds its QR code with Java's Long.toHexString, which
 * never pads; a padded code (leading 0) does not scan in the mobile app.
 */
export function crc32Hex(input: string): string {
  return crc32(input).toString(16).toUpperCase();
}
